if (!customElements.get('cb-reviews-deck')) {
  customElements.define('cb-reviews-deck', class extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('[data-cb-rd-card]')];
      this.n = this.cards.length;
      if (this.n < 2) return;
      this.i = 0;
      this.stack = this.querySelector('[data-cb-rd-stack]');
      this.bar = this.querySelector('[data-cb-rd-bar]');
      this.count = this.querySelector('[data-cb-rd-count]');
      this.toggle = this.querySelector('[data-cb-rd-toggle]');
      this.auto = this.hasAttribute('data-autoplay') && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.paused = !this.auto;

      this.querySelector('[data-cb-rd-prev]').addEventListener('click', () => this.go(-1, true));
      this.querySelector('[data-cb-rd-next]').addEventListener('click', () => this.go(1, true));
      this.bar.addEventListener('animationend', () => this.go(1));
      if (this.toggle) {
        if (!this.auto) this.toggle.hidden = true;
        this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.sync(); });
      }

      this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { this.hover = true; this.sync(); } });
      this.addEventListener('pointerleave', () => { this.hover = false; this.sync(); });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.sync(); } });
      this.onVis = () => this.sync();
      document.addEventListener('visibilitychange', this.onVis);
      this.io = new IntersectionObserver(([e]) => { this.visible = e.isIntersecting; this.sync(); }, { threshold: 0.35 });
      this.io.observe(this);

      // Swipe; a real drag must not open the card link
      let x0 = null, moved = false;
      this.stack.addEventListener('pointerdown', (e) => { x0 = e.clientX; moved = false; });
      this.stack.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) { moved = true; this.go(dx < 0 ? 1 : -1, true); }
      });
      this.stack.addEventListener('click', (e) => { if (moved) { e.preventDefault(); moved = false; } }, true);

      // Theme editor: show the selected block
      this.onSelect = (e) => {
        const k = this.cards.indexOf(e.target);
        if (k > -1) { this.paused = true; this.go(k - this.i, true); }
      };
      document.addEventListener('shopify:block:select', this.onSelect);

      this.restart();
      this.sync();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      document.removeEventListener('visibilitychange', this.onVis);
      document.removeEventListener('shopify:block:select', this.onSelect);
    }

    go(d, manual) {
      const out = this.i;
      this.i = (this.i + d + this.n) % this.n;
      if (manual) this.stack.setAttribute('aria-live', 'polite');
      this.cards.forEach((c, k) => {
        const pos = (k - this.i + this.n) % this.n;
        if (pos < 3) c.dataset.pos = pos;
        else if (d > 0 && k === out) c.dataset.pos = 'out';
        else delete c.dataset.pos;
        c.inert = pos !== 0;
        c.setAttribute('aria-hidden', pos !== 0);
      });
      const pad = (v) => String(v).padStart(2, '0');
      this.count.textContent = pad(this.i + 1) + ' / ' + pad(this.n);
      this.restart();
    }

    restart() {
      this.bar.classList.remove('is-anim');
      void this.bar.offsetWidth;
      this.bar.classList.add('is-anim');
    }

    sync() {
      const run = this.auto && !this.paused && this.visible && !this.hover && !this.focused && !document.hidden;
      this.toggleAttribute('data-running', !!run);
      if (this.toggle) {
        this.toggle.setAttribute('aria-pressed', this.paused);
        this.toggle.setAttribute('aria-label', this.paused ? 'Play reviews' : 'Pause reviews');
      }
    }
  });
}
